

























import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import SudokuBoard from "@/@modules/Sudoku/SudokuBoard";

@Component
export default class SudokuBoardComponent extends Vue {
  @Prop() originalBoard!: SudokuBoard;
  @Prop() board!: SudokuBoard;

  selected: [number, number] = [-1, -1];

  getValue(row: number, col: number) {
    return this.board[row][col] || "";
  }

  onArrow(event: KeyboardEvent) {
    let [row, col] = this.selected;

    // Left
    if (event.keyCode == 37) {
      event.preventDefault();
      col--;
    }

    // Right
    if (event.keyCode == 39) {
      event.preventDefault();
      col++;
    }

    // Up
    if (event.keyCode == 38) {
      event.preventDefault();
      row--;
    }

    // Down
    if (event.keyCode == 40) {
      event.preventDefault();
      row++;
    }

    if (col < 0) col = 0;
    if (col > 8) col = 8;
    if (row < 0) row = 0;
    if (row > 8) row = 8;

    this.selected = [row, col];
    this.focusSelectedInput();
  }

  onFocus(row: number, col: number) {
    this.selected = [row, col];

    const element = this.getSelectedInput();
    if (!element) return;
    element.select();
  }

  onBlur(row: number, col: number) {
    if (row == this.selected[0] && col == this.selected[1]) {
      this.selected = [-1, -1];
    }
  }

  getSelectedInput() {
    let elements = this.$refs["input-" + this.selected.join("-")] as
      | HTMLInputElement[]
      | HTMLInputElement
      | undefined;
    if (!elements) return;

    let element: HTMLInputElement;
    if (Array.isArray(elements)) element = elements[0];
    else element = elements;

    return element;
  }

  focusSelectedInput() {
    const element = this.getSelectedInput();
    if (!element) return;
    element.focus();
    element.select();
  }

  setValue(row: number, col: number, input: HTMLInputElement) {
    const numValue = Number(input.value) % 10;
    if (numValue > 9 || numValue < 1) {
      this.$set(this.board[row], col, 0);
      return;
    }

    this.$set(this.board[row], col, numValue);
  }
}
